const TOKEN_PATH_PATTERN = /^\/(?:accept-invite|reset-password|verify-email|partner-redirect)\/[^/]+$/;
const ACCEPT_INVITATION_CONFIRM_PATH = '/accept-invite/confirm';
const RESET_PASSWORD_CONFIRM_PATH = '/reset-password/confirm';
const LOGIN_PATH = '/login';
const EXPORT_SUCCESS_PATH = '/businesses/export/success';
const INTEGRATIONS_PATH = '/integrations';
const OAUTH_AUTHORIZE_PATH = '/oauth/authorize';
const API_KEY_PATH = '/api-key';
const API_DOCS_PATH = '/api-docs';
const OAUTH_CALLBACK_PARAMS = ['code', 'state', 'error', 'error_description'];

export const matchesSensitiveRoute = ({ pathname = '', search = '' } = {}) => {
  const normalizedPath = pathname.replace(/\/+$/, '').toLowerCase() || '/';

  if (
    normalizedPath === ACCEPT_INVITATION_CONFIRM_PATH ||
    normalizedPath === RESET_PASSWORD_CONFIRM_PATH ||
    normalizedPath === OAUTH_AUTHORIZE_PATH ||
    normalizedPath === API_KEY_PATH ||
    normalizedPath === API_DOCS_PATH ||
    TOKEN_PATH_PATTERN.test(normalizedPath)
  ) {
    return true;
  }

  const searchParams = new URLSearchParams(search);

  if (normalizedPath === LOGIN_PATH && searchParams.has('email')) {
    return true;
  }

  if (normalizedPath === INTEGRATIONS_PATH) {
    if (OAUTH_CALLBACK_PARAMS.some(param => searchParams.has(param))) {
      return true;
    }
  }

  return normalizedPath === EXPORT_SUCCESS_PATH;
};

export const isSensitiveRoute = (location) => {
  if (typeof window === 'undefined') {
    return matchesSensitiveRoute(location);
  }

  return matchesSensitiveRoute(location || window.location);
};
